import { call, put, takeLatest } from "redux-saga/effects";
import { constructUrl } from "@pl/paylican-ui-kit";
import { setRequestInProcess } from "../request/actions";
import invoicesApiService from "../../services/invoicesApiService";
import { agentAdapter } from "../../utils/agentAdaptors";
import * as actions from "./actions";
import { deleteInvoiceAgent } from "../invoice/actions";
import { FETCHING_AGENT, SEARCH_AGENT, ADD_AGENT, DELETE_AGENT } from "./types";
import { hideModal, showModal } from "../modal/actions";
import modalNames from "../../constants/modalNames";
import { invoice } from "../../constants/pathnames";

function* fetchAgentAsync(action) {
  try {
    yield put(setRequestInProcess(FETCHING_AGENT, true));

    const id = action.payload;
    const response = yield call(x => invoicesApiService.getAgent(x), id);

    yield put(setRequestInProcess(FETCHING_AGENT, false));

    if (response.hasError) {
      yield put(
        actions.fetchingAgentError(response.errors.map(error => ({ ...error, id: `currentAgent_${error.id}` })))
      );
    } else {
      const agent = response.payload?.invoiceAgents?.find(i => i.invoiceNumber === id)?.customer;
      yield put(actions.fetchingAgentSuccess(agentAdapter(agent)));
    }
  } catch (err) {
    yield put(actions.fetchingAgentError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* watchFetchAgentAsync() {
  yield takeLatest(FETCHING_AGENT, fetchAgentAsync);
}

function* searchAgentAsync(action) {
  try {
    yield put(setRequestInProcess(SEARCH_AGENT, true));

    const tin = action.payload;
    const response = yield call(x => invoicesApiService.searchAgent(x), tin);

    yield put(setRequestInProcess(SEARCH_AGENT, false));

    if (response.hasError) {
      yield put(actions.searchAgentError(response.errors));
    } else {
      yield put(actions.searchAgentSuccess(response.payload));
    }
  } catch (err) {
    yield put(actions.searchAgentError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* watchSearchAgentAsync() {
  yield takeLatest(SEARCH_AGENT, searchAgentAsync);
}

function* addAgentAsync(action) {
  try {
    yield put(setRequestInProcess(ADD_AGENT, true));

    const { invoiceId, agentCode, navigate } = action.payload;
    const response = yield call((id, code) => invoicesApiService.addAgent(id, code), invoiceId, agentCode);

    yield put(setRequestInProcess(ADD_AGENT, false));

    yield put(hideModal(modalNames.MODIFY_INVOICE_MODAL));
    if (response.hasError) {
      yield put(actions.addAgentError(response.errors));
      yield put(showModal(modalNames.ERROR_MODAL, { errors: response.errors }));
    } else {
      yield put(actions.addAgentSuccess(agentAdapter(response.payload)));
      yield put(actions.clearSearch());
      yield call(navigate(constructUrl(invoice, { id: invoiceId })));
    }
  } catch (err) {
    yield put(actions.addAgentError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* watchAddAgentAsync() {
  yield takeLatest(ADD_AGENT, addAgentAsync);
}

function* deleteAgentAsync(action) {
  try {
    yield put(setRequestInProcess(DELETE_AGENT, true));

    const response = yield call(x => invoicesApiService.deleteAgent(x), action.payload);

    yield put(setRequestInProcess(DELETE_AGENT, false));

    yield put(hideModal(modalNames.UNSHARE_INVOICE_MODAL));
    if (response.hasError) {
      yield put(actions.deleteAgentError(response.errors));
      yield put(showModal(modalNames.ERROR_MODAL, { errors: response.errors }));
    } else {
      yield put(actions.deleteAgentSuccess(response.payload));
      yield put(deleteInvoiceAgent());
    }
  } catch (err) {
    yield put(actions.deleteAgentError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* watchDeleteAgentAsync() {
  yield takeLatest(DELETE_AGENT, deleteAgentAsync);
}

export { watchFetchAgentAsync, watchSearchAgentAsync, watchAddAgentAsync, watchDeleteAgentAsync };
